__turbopack_context__.v({
  "Noevents": "HQGTcW_Noevents",
  "bannerButton": "HQGTcW_bannerButton",
  "bannerSection": "HQGTcW_bannerSection",
  "banner_inner": "HQGTcW_banner_inner",
  "btn_more": "HQGTcW_btn_more",
  "build_btn": "HQGTcW_build_btn",
  "buttonContent": "HQGTcW_buttonContent",
  "buttonGroup": "HQGTcW_buttonGroup",
  "buttonIcon": "HQGTcW_buttonIcon",
  "carousel-container": "HQGTcW_carousel-container",
  "contentWrapper": "HQGTcW_contentWrapper",
  "date_month": "HQGTcW_date_month",
  "event": "HQGTcW_event",
  "event_category": "HQGTcW_event_category",
  "event_date": "HQGTcW_event_date",
  "event_details": "HQGTcW_event_details",
  "event_item": "HQGTcW_event_item",
  "event_p": "HQGTcW_event_p",
  "event_title": "HQGTcW_event_title",
  "event_title_p": "HQGTcW_event_title_p",
  "event_title_section": "HQGTcW_event_title_section",
  "imageSection": "HQGTcW_imageSection",
  "more_section": "HQGTcW_more_section",
  "noEvent": "HQGTcW_noEvent",
  "textSection": "HQGTcW_textSection",
  "txt_a": "HQGTcW_txt_a",
  "visually-hidden": "HQGTcW_visually-hidden",
  "visually_hidden": "HQGTcW_visually_hidden",
});
